import { useEffect, useState } from 'react';
import { BiChevronDown, BiChevronUp } from "react-icons/bi"; 
import Icons from './icons'; 

const Group = ({ title, sideBar, links, handleLinkClick, selectedItem}) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleSubItems = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        if (!selectedItem.includes('/')) {
            setIsOpen(false);
        }
    }, [selectedItem]);

    const margItem = sideBar ? 15 : 0;

    return (
        <div className="w-full">
            <div 
                className={`flex items-center p-3 cursor-pointer group transition-all duration-200 hover:transform hover:translate-x-1 ${!sideBar ? 'justify-center' : 'justify-between'}`}
                onClick={toggleSubItems}
                data-tour-id={`menu:${title}`}
            >
                <div className={`flex items-center ${!sideBar ? 'justify-center w-full' : ''}`}>
                    <div className="flex items-center justify-center w-8 h-8 text-white group-hover:text-vox-green-400 transition-colors duration-200">
                        {Icons(title, sideBar, 24)} 
                    </div>
                    {sideBar && (
                        <span className="ml-3 font-medium text-white group-hover:text-vox-green-400 transition-colors duration-200">
                            {title}
                        </span>
                    )}
                </div>
                {sideBar && (
                    <div className="text-white group-hover:text-vox-green-400 transition-all duration-200">
                        {isOpen ? <BiChevronUp className="w-5 h-5" /> : <BiChevronDown className="w-5 h-5" />}
                    </div>
                )}
            </div>
            {isOpen && (
                <div className="overflow-hidden transition-all duration-300">
                    {links.map((subItem, index) => (
                        <div
                            key={index}
                            className={`
                                flex items-center p-2 pl-6 cursor-pointer transition-all duration-200 
                                hover:bg-vox-blue-600 dark:hover:bg-gray-600 hover:transform hover:translate-x-1
                                ${selectedItem === subItem.link ? 
                                    'bg-vox-green-500 border-l-4 border-vox-green-300 text-white' : 
                                    'text-gray-300 hover:text-white'
                                }
                                ${sideBar ? 'ml-4' : ''}
                            `}
                            onClick={() => handleLinkClick(subItem.link)}
                        >
                            {!sideBar && (
                                <div className="flex items-center justify-center w-6 h-6">
                                    {Icons(subItem.name, false, 20)}
                                </div>
                            )}
                            {sideBar && (
                                <span className="text-sm font-medium">
                                    {subItem.name}
                                </span>
                            )} 
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Group;
